// removed by extract-text-webpack-plugin
module.exports = {"pgx-modal":"pgx-modal","danger-btn":"danger-btn","primary-btn":"primary-btn"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/normal/MaterialModal/Index.scss
// module id = 1386
// module chunks = 0